module.exports = __webpack_public_path__ + "img/brushes-cn-2.ba8d9db.jpg";